var _path, _path2, _path3, _mask, _rect, _path4, _mask2, _rect2, _path5, _mask3, _rect3, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturesSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 95,
    viewBox: "0 0 160 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 85V74.625M4 85V10a8 8 0 0 1 8-8h110a8 8 0 0 1 8 8v5.5",
    stroke: "#8F55FF",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 92A1.5 1.5 0 0 0 3 93.5h128a1.5 1.5 0 0 0 1.5-1.5v-7a1.5 1.5 0 0 0-1.5-1.5H77.475a1.5 1.5 0 0 0-.882.287l-1.172.852a4.5 4.5 0 0 1-2.647.861H61.227a4.5 4.5 0 0 1-2.647-.86l-1.172-.853a1.5 1.5 0 0 0-.883-.287H3A1.5 1.5 0 0 0 1.5 85v7Z",
    stroke: "#8F55FF",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.525 68.05c12.44 0 22.525-10.085 22.525-22.525 0-12.44-10.085-22.525-22.525-22.525C112.085 23 102 33.085 102 45.525c0 12.44 10.085 22.525 22.525 22.525ZM157.65 76l-17.225-14.575",
    stroke: "#8F55FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_786_18990",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    width: 21,
    height: 14,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    width: 21,
    height: 14,
    rx: 2,
    stroke: "#8F55FF",
    strokeWidth: 6,
    mask: "url(#path-5-inside-1_786_18990)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F55FF",
    d: "M40 18h55v3H40zM40 23h18v3H40z"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-2_786_18990",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 39,
    width: 21,
    height: 14,
    rx: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 39,
    width: 21,
    height: 14,
    rx: 2,
    stroke: "#8F55FF",
    strokeWidth: 6,
    mask: "url(#path-8-inside-2_786_18990)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 40h47v3H40v-3ZM40 45h18v3H40z",
    fill: "#8F55FF"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-3_786_18990",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 61,
    width: 21,
    height: 14,
    rx: 2
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 61,
    width: 21,
    height: 14,
    rx: 2,
    stroke: "#8F55FF",
    strokeWidth: 6,
    mask: "url(#path-11-inside-3_786_18990)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F55FF",
    d: "M40 62h55v3H40zM40 67h18v3H40z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesSearch);
export default __webpack_public_path__ + "static/media/features-search.bda3af94073a2080defe797d3f3a13d7.svg";
export { ForwardRef as ReactComponent };